<template>
  <div class="container">
      <div class="intro-banner">
          <div class="intro-write">
            <p class="p1">公司简介</p>
            <p class="p2">COMPANY PROFILE</p>
          </div>
      </div>
      <div class="intro-content">
        <!-- <div class="timeline">
            <div v-for="(event, index) in events"  :key="index" class="timeline-event" :class="{ 'left': index % 2 === 0, 'right': index % 2 !== 0 }">
              <div class="event-content">
                <div class="event-date">
                 <span class="font-medium"> {{ event.date }}</span>
                  <img :src="event.img" alt="">
                </div>
                <ul>
                  <li class="event-description" v-for="(eve, desindex) in event.even"  :key="desindex">
                    <div class="eve-left"  >
                      <span v-if="index % 2 != 0" class="left" >{{ eve.month }}</span>
                        <template v-for="item in eve.descript" >
                          <span v-if="item.type === 'bold'" class="bold">{{ item.text }}</span>
                          <em v-else-if="item.type === 'italic'" class="italic">{{ item.text }}</em>
                          <span v-else  class="else">{{ item.text }}</span>
                        </template>
                        <span v-if="index % 2 === 0" class="left" >{{ eve.month }}</span>
                    </div> -->
                    <!-- <span :class="{ 'left': index % 2 === 0, 'right': index % 2 !== 0 }">{{ eve.month }}</span> -->
                    <!-- {{ eve.descript }} -->
                    <!-- <span v-for="item in eve.descript" :key="item.id" class="spanall">
                      <span v-if="item.type === 'bold'" class="bold">{{ item.text }}</span>
                      <span v-else-if="item.type === 'italic'" class="italic">{{ item.text }}</span>
                      <span v-else  class="else">{{ item.text }}</span>
                    </span> -->
                  <!-- </li>
                </ul>
              </div>
            </div>
          </div> -->
        <div class="intro-min">
          <!-- 时间轴 -->
            <div class="intro-main-min">
              <!-- 左 -->
              <div class="intro-main-left">
                <div class="intro-main-content">
                    <p class="p1" style="position:relative"><span class="spanall"><span class="bold">“上海索洛信息技术有限公司”</span>成立</span><span class="month">8月</span><i></i></p>
                    <p class="p1"><span class="spanall">自媒体</span><span class="bold">「一犬一话」</span><span class="spanall">推出</span><span class="month">8月</span></p>
                    <p class="p1"><span class="spanall">承办超350名主人与宠物的<span class="bold">第七届月湖雕塑公园<br/>狗粉丝聚会</span></span><span class="month">10月</span></p>
                </div>
                <div class="intro-main-image" style="margin: 65px 0 151px;">
                  <img src="../assets/intro/pic_1.png" />
                  <span class="font-medium">2016</span>
                </div>
                <div class="intro-main-content02">
                    <p class="p1" style="padding-bottom: 26px;position:relative"><span class="spanall"><span class="bold">Pre-A轮融资</span>，数百万人民币，投资方为九合创投、<br/>长石资本、禾溪投资</span><span class="month">6月</span><i></i></p>
                    <p class="p1" style="padding-bottom: 26px;"><span class="spanall">推出宠物订阅制电商新品牌<br/><span class="bold">「MollyBox魔力猫盒」</span></span><span class="month">8月</span></p>
                    <p class="p1" style="padding-bottom: 26px;"><span class="spanall">荣获<span class="bold">福布斯30 Under 30</span></span><span class="month">8月</span></p>
                    <p class="p1" ><span class="spanall"><span class="bold">第八届月湖公园狗粉丝聚会</span>。汇聚600余名主人与宠物<br/>是上海地区规模领先的线下宠友聚会活动之一</span><span class="month">9月</span></p>
                    <p class="p1" ><span class="spanall">数百万美元的<span class="bold">A轮融资</span>，投资方为DCM资本、<br/>原子创投、九合创投</span><span class="month">12月</span></p>
                    <p class="p1" ><span class="spanall">参与<span class="bold">第二届上海宠物领养日活动</span></span><span class="month">12月</span></p>
                </div>
                <div class="intro-main-image" style="margin: 70px 0 720px;">
                  <img src="../assets/intro/pic_3.png" />
                  <span class="font-medium">2018</span>
                </div>
                <div class="intro-main-content02 intro-main-content03">     
                   <p class="p1" style="position:relative"><span class="spanall"><span class="bold">魔力猫盒</span>与国漫<span class="bold">《京剧猫》</span>，开展了一场新春联合<br/>活动，将新文创势力带进了宠物行业</span><span class="month">1月</span><i></i></p>
                   <p class="p1" style="position:relative"><span class="spanall">获得<span class="bold">1300万美元</span>B轮融资</span><span class="month">3月</span></p>
                   <p class="p1" style="position:relative"><span class="spanall">参与线下<span class="bold">宠博会</span>-极有家活动</span><span class="month">4月</span></p>
                   <p class="p1" style="position:relative"><span class="spanall">推出<span class="bold">阴阳师</span>公益限量联名盒魔力猫盒与国漫</span><span class="month">6月</span></p>
                   <p class="p1" style="position:relative"><span class="spanall">MollyBox魔力猫盒开通天猫旗舰店</span><span class="month">8月</span></p>
                   <p class="p1" style="position:relative"><span class="spanall">MollyBox魔力猫盒参与<span class="bold">2019上海亚宠展</span></span><span class="month">8月</span></p>
                   <p class="p1" style="position:relative"><span class="spanall">推出<span class="bold">新西兰国家联名</span>纯净猫盒</span><span class="month">9月</span></p>
                   <p class="p1" style="position:relative"><span class="spanall">推出<span class="bold">TA公益联名</span>猫盒</span><span class="month">9月</span></p>
                   <p class="p1" style="position:relative"><span class="spanall">推出<span class="bold">36氪联名</span>猫盒</span><span class="month">10月</span></p>
                   <p class="p1" style="position:relative"><span class="spanall">MollyBox魔力猫盒天猫旗舰店<span class="bold">双十一销售额<br/>超过600W</span></span><span class="month">11月</span></p>
                   <p class="p1" style="position:relative"><span class="spanall">推出<span class="bold">陈情令联名</span>猫盒</span><span class="month">11月</span></p>
                </div>
                <div class="intro-main-image" style="margin: 55px 0 122px;">
                  <img src="../assets/intro/pic_7.png" />
                  <span class="font-medium">2020</span>
                </div>
                <div class="intro-main-image" style="margin: 25px 0 157px;">
                  <span class="font-medium" style="right:62px;">未来</span>
                </div>
              </div> 
              <!-- 中 -->
              <div class="intro-main-center">

              </div>
              <!-- 右 -->
              <div class="intro-main-right" style="top:0">
                <div class="intro-main-image intro-main-image1">
                    <!-- <img src="../assets/intro/pic_1.png" /> -->
                    <span class="font-medium">2015</span>
                  </div>
                  <div class="intro-main-content">
                      <p class="p1" style="position:relative"><i></i><span class="month">5月</span><span class="spanall">完成天使轮 <span class="bold">200万</span>人民币，九合创投</span></p>
                      <p class="p1"><span class="month">8月</span><span class="spanall"><span class="bold">「一犬一话」</span>推出<span class="bold">Woof Box</span>订阅服务</span></p>
                      <p class="p1"><span class="month">10月</span><span class="spanall">自媒体<span class="bold">「一犬一话」</span>已成长为上海宠物类广告媒体领域的头部品牌，在本地宠物圈中拥有广泛影响力。</span></p>
                  </div>
                  <div class="intro-main-image intro-main-image2">
                    <img src="../assets/intro/pic_2.jpg" />
                    <span class="font-medium">2017</span>
                  </div>
                  <div class="intro-main-content">   
                      <p class="p1" style="padding-bottom: 24px;position:relative"><i></i><span class="month">5月</span><span class="spanall">荣获胡润<span class="bold">30 Under 30</span>奖项</span></p>
                      <p class="p1" style="padding-bottom: 27px;"><span class="month">5月</span><span class="spanall">携手上海公益组织：上海领养日&二月猫发起“让爱不再流浪”线上公益助养活动，超过<span class="bold">97万</span>爱心人士参与，帮助<span class="bold">百万只猫咪</span>寻求领养机会</span></p>
                      <p class="p1" style="padding-bottom: 27px;"><span class="month">5月</span><span class="spanall">推出了自己的MCN公司-<span class="bold">38度媒体</span>，旗下有超过<span class="bold">120名</span>萌宠网红博主覆盖微博、抖音、小红书近<span class="bold">4000万</span>名用户</span></p>
                      <p class="p1" style="padding-bottom: 31px;"><span class="month">10月</span><span class="spanall">再度与<span class="bold">TA上海</span>深度合作，发起微博“<span class="bold">流浪猫善待计划</span>”，并向TA上海捐助救助金；举办猫粮公益义卖活动，帮助流浪猫进行TNR救助</span></p>
                      <p class="p1" style="padding-bottom: 29px;"><span class="month">10月</span><span class="spanall">推出宠物会员制电商品牌<span class="bold">「六脚兽」</span>会员制电商</span></p>
                      <p class="p1" style="padding-bottom: 27px;"><span class="month">10月</span><span class="spanall"><span class="bold">第三届月湖雕塑公园</span>狗粉丝聚会，超400吸引超过400位粉丝参与</span></p>
                      <p class="p1" style="padding-bottom: 24px;"><span class="month">11月</span><span class="spanall">荣获天使基金“<span class="bold">雏鹰奖</span>”、荣获Fast Company 50 Most Innovative Company</span></p>
                      <p class="p1" style="padding-bottom: 24px;"><span class="month">11月</span><span class="spanall">数千万美元的<span class="bold">A轮融资</span>，投资方为DCM、Digitalis Benture、Unity Venture、Seek Venture、FJ Lab等。</span></p>
                      <p class="p1" style="padding-bottom: 0;"><span class="month">11月</span><span class="spanall">参与宣誓品牌承诺：“<span class="bold">在售商品均为正品，为每一件商品的质量与来源负责。</span>”</span></p>
                  </div>
                  <div class="intro-main-image intro-main-image3">
                    <img src="../assets/intro/pic_4.jpg" />
                    <span class="font-medium">2019</span>
                  </div>
                  <div class="intro-main-content">   
                      <p class="p1" style="padding-bottom: 24px;position:relative"><i></i><span class="month">1月</span><span class="spanall">获得<span class="bold">1500万美元</span>B+轮融资</span></p>
                      <p class="p1" style="padding-bottom: 27px;"><span class="month">1月</span><span class="spanall">推出<span class="bold">西安博物院国潮风</span>猫盒</span></p>
                  </div>
                  <div class="intro-main-content" style="padding-top:285px">     
                    <p class="p1" style="position:relative"><i></i><span class="fature">我们脚踏实地，用心服务好每一位用户。让养宠更轻松，让宠物生活更健康、更安心，让人、动物与城市和谐共生，共创美好未来。</span></p>
                  </div>
              </div>
            </div>
        </div>
      </div>
      <div class="intro-footer">
        <div class="intro-footer-title">
          <img class="img1" src="../assets/intro/pic_5.png" />
          <p class="p1">产品体验团队成员</p>
          <p class="p2">MEMBER OF FAMILY</p>
        </div>
        <div class="intro-footer-main">
          
          <div class="intro-main-center">
            <ul>
              <li v-for="(item,index) in items" :key="index">
                  <i><img :src="item.img" /></i>
                  <p class="p1">{{item.name}}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'intro',
  data(){
    return{
      events: [
        // {
        //   date: "2023",
        //   img: require('@/assets/intro/pic_2.jpg') ,
        //   even:[
        //     {
        //       month:"8月",
        //       descript: [
        //         { type: "bold", text: "“上海索洛信息技术有限公司”" },
        //         { type: "text", text: "成立" },
        //       ],
        //     },{
        //       month:"9月",
        //       descript: [
        //         { type: "text", text: "自媒体" },
        //         { type: "bold", text: "「一犬一话」" },
        //         { type: "text", text: "推出" },
        //       ],
        //     },
        //     {
        //       month:"9月",
        //       descript: [
        //         { type: "text", text: "承办超350名主人与宠物的" },
        //         { type: "bold", text: "第七届月湖雕塑公园" },
        //         { type: "text", text: "狗粉丝聚会" },
        //       ],
        //     },
        //   ]
        // },
        // {
        //   date: "2016",
        //   img: require('@/assets/intro/pic_1.png') ,
        //   even:[
        //     {
        //       month:"5月",
        //       descript: [
        //         { type: "text", text: "完成天使轮" },
        //         { type: "bold", text: "200万" },
        //         { type: "text", text: "人民币，九合创投" },
        //       ],
        //     },
        //     {
        //       month:"8月",
        //       descript: [
        //         { type: "bold", text: "「一犬一话」" },
        //         { type: "text", text: "推出" },
        //         { type: "bold", text: "Woof Box" },
        //         { type: "text", text: "订阅服务" },
        //       ],
        //     },
        //     {
        //       month:"10月",
        //       descript: [
        //         { type: "text", text: "自媒体" },
        //         { type: "bold", text: "「一犬一话」" },
        //         { type: "text", text: "成长为上海宠物类广告媒体第一品牌" },
        //       ],
        //     },
        //   ]
        // },
        // {
        //   date: "2023",
        //   even:[
        //     {
        //       month:"8月",
        //       description: "项目正式启动，团队开始规划需求和设计。",
        //     },{
        //       month:"9月",
        //       description: "项目正式启动，团队开始规划需求和设计。",
        //     },
        //   ]
        // },
      ],
      items:[
        {
          img:require('../assets/intro/peigen.png'),
          name:'培根'
        },
        {
          img:require('../assets/intro/miantiao.png'),
          name:'面条'
        },
        {
          img:require('../assets/intro/zhima.png'),
          name:'芝麻'
        },
        {
          img:require('../assets/intro/dabing.png'),
          name:'大饼'
        },
        {
          img:require('../assets/intro/bohetang.png'),
          name:'薄荷糖'
        },
        {
          img:require('../assets/intro/jignjing.png'),
          name:'静静'
        },
        {
          img:require('../assets/intro/pangpang.png'),
          name:'胖胖'
        },
        {
          img:require('../assets/intro/midi.png'),
          name:'迷弟'
        },
        {
          img:require('../assets/intro/dage.png'),
          name:'大哥'
        },
        {
          img:require('../assets/intro/maotai.png'),
          name:'茅台'
        },
        {
          img:require('../assets/intro/youtiao.png'),
          name:'油条'
        },
        {
          img:require('../assets/intro/wuyazai.png'),
          name:'无牙仔'
        },
        {
          img:require('../assets/intro/ximilu.png'),
          name:'西米露'
        },
        {
          img:require('../assets/intro/kouyi.png'),
          name:'扣一'
        },
        {
          img:require('../assets/intro/lanqiu.png'),
          name:'篮球'
        },
        {
          img:require('../assets/intro/mieba.png'),
          name:'灭霸'
        },
        {
          img:require('../assets/intro/weibo.png'),
          name:'围脖'
        },
        {
          img:require('../assets/intro/shoutao.png'),
          name:'手套'
        },
      ]
    }
  },
}
</script>

<style scoped lang="less">
 .timeline {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 0;
}

.timeline::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  width: 4px;
  background: linear-gradient(to bottom, #b2261e, #ececec);
  transform: translateX(-50%);
}

.timeline-event {
  padding: 20px;
  position: relative;
  width: 50%;
  animation: fadeIn 0.6s ease-in-out;
}

.timeline-event.left {
  left: 0;
  text-align: right;
}

.timeline-event.right {
  left: 50%;
  text-align: left;
}

.event-content {
  padding: 20px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  position: relative;
}

.event-content::before {
  content: "";
  position: absolute;
  top: 20px;
  width: 0;
  height: 0;
  border-style: solid;
}

.timeline-event.left .event-content::before {
  right: -10px;
  border-width: 10px 0 10px 10px;
  border-color: transparent transparent transparent white;
}

.timeline-event.right .event-content::before {
  left: -10px;
  border-width: 10px 10px 10px 0;
  border-color: transparent white transparent transparent;
}

.event-date img{
  // width: 488px;
  // height: 277px;
  // background-color: #eedece; 
    
}
.event-date span{
  background-color: #e6e6e6;
  opacity: 0.75;
  font-size: 34px;
  text-align: center;
  line-height: 61px;
  letter-spacing: 0px;
  color: #b2261e;
  font-weight: bold;
}

.event-title {
  font-size: 20px;
  color: #333;
  margin-bottom: 10px;
}

.event-description {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
  // display: flex;
  // justify-content:flex-end;
  // padding-bottom:  30px;
  .eve-left{
    display: flex;
    justify-content: flex-end;
    padding-bottom: 30px;
    font-size: 20px;
  }
  .left{
    display: flex;
    justify-content: flex-end;
  }
  .right{

  }
  .bold{
    .strang;
  }
  .spanall{
    .spanallall;
  }
  .month{
    .spantineall
  }
            
              
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .timeline::before {
    left: 20px;
  }

  .timeline-event {
    width: 100%;
    left: 0 !important;
    text-align: left !important;
    padding-left: 50px;
  }

  .timeline-event.right {
    left: 0 !important;
  }

  .event-content::before {
    left: -10px !important;
    border-width: 10px 10px 10px 0 !important;
    border-color: transparent white transparent transparent !important;
  }
}


  .font-medium{font-weight: 600;}
  .intro-banner{
      width: 100%;
      height: 400px;
      background: url('../assets/intro/banner.jpg') center center no-repeat;
      background-size:cover ;
      // min-height: 100vh;
      text-align: center;
      .intro-write{
        padding-top: 98px;
        .p1{
          font-size: 40px;
          letter-spacing: 6px;
          color: #fff;
          padding: 116px 0 27px;
          font-weight: 600;
        }  
        .p2{
          font-size: 20px;
          letter-spacing: 5px;
          color: #fff;
        }  
      }
  }
  .intro-content{
    .intro-min{
      width: 1116px;
      margin: 0 auto;
      .intro-main-min{
        padding-top: 104px;
        overflow: hidden;
        display: flex;
        .intro-main-left{
          width: 570px;
          background: #fff;
          p{text-align: right;}
          .intro-main-content{
            padding-top:60px; 
            line-height: 29px;
            .p1{
               display: flex;
              // align-items: center;
              justify-content:flex-end;
              padding-bottom:  30px;
              // line-height: 29px;
              .bold{
                .strang;
              }
              .spanall{
                .spanallall;
              }
              .month{
                .spantineall
              }
              i{
                .yuan;
                right: -9px;
                top: 3px;
              }
            }
          }
          .intro-main-image{
            margin: 80px 0 157px;
            position: relative;
            text-align: right;
            padding-right: 62px;
            img{
              width: 488px;
              height: 277px;
              background-color: #eedece;
            }
            span{
              .spanbuttonleft;
            }
          }
          .intro-main-image2{
            margin: 65px 0 151px;
          }
          .intro-main-content02{
            text-align: justify;
            .p1{
              display: flex;
              // align-items: center;
              justify-content:flex-end;
              padding-bottom: 26px;
              line-height: 29px;
              .bold{
                .strang;
              }
              .spanall{
                .spanallall;
              }
              .month{
                .spantineall
              }
              i{
                .yuan;
                right: -9px;
                top: (31-14)/2px;
              }
            }
          }
          .intro-main-content03{
            .p1{
              padding-bottom: 38px;
              line-height: 29px;
            }
          }
        }
        .intro-main-center{
          width: 4px;
          margin: 66px 0 102px;
          background: #ececec;
        }
        .intro-main-right{
          width: 542px;
          background: #fff;
          .intro-main-content{
            text-align: justify;
            .fature{ 
              padding-left:62px;
              width:479px;
              font-size: 20px;
              line-height: 31px;
              color: #000000;
              font-weight: 600;
            }
            .p1{
               display: flex;
              justify-content:flex-start;
              padding-bottom:  26px;
              line-height: 31px;
              .bold{
                .strang;
              }
              .spanall{
                .spanallall;
                width: 392px;
              }
              .month{
                font-size: 20px;
                width: 80px;
                display: inline-block;
                padding-left: 62px;
                text-align: left;
                letter-spacing: 0px;
                color: #000000;
              }
            }
            i{
              .yuan;
              left: -9px;
              top: 8.5px
            }
           }
          .intro-main-image{
            margin-left: 62px;
            position: relative;
            text-align: right;
            padding-right: 6px;
            img{
              width: 488px;
              height: 277px;
              background-color: #eedece;
            }
            span{
              position: absolute;
              left: -20px;
              top: -18px;
              display: block;
              width: 121px;
              height: 61px;
              background-color: #e6e6e6;
              opacity: 0.75;
              font-size: 34px;
              text-align: center;
              line-height: 61px;
              letter-spacing: 0px;
              color: #b2261e;
            }
          }
          .intro-main-image1{
            height: 61px;
            margin-bottom: 300px;
            span{
              top: 0px;
            }
          }
          .intro-main-image2{
            margin: 151px 0 320px 62px;
          }
          .intro-main-image3{
            margin: 93px 0 644px 62px;
          }
        }
      }
    }
  }
  .intro-footer{
    margin-top:218px;
    background-color: #f5f2f0; 
    .intro-footer-title{
       position: relative;
      .img1{
        position: absolute;
        left: 0;
        top: -18px;
        z-index: 50;
        width: 390px;
        height: 398px;
      }
      text-align: center;
      .p1{
        .businessp1;
      }
      .p2{
        .businessp2;
      }
    }
    .intro-footer-main{
      background-image: url('../assets/intro/pic_6.png');
      background-repeat: no-repeat;
      background-position: right bottom;
      background-size: 631px 293px;
      .intro-main-center{
        width: 1122px;
        margin:  40px auto 0;
        padding-bottom: 107px;
        ul{
          overflow: hidden;
          li{
            float: left;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            // padding: 0 11px;
            width: 1122/4px;
            
            i{
              width: 256px;
              height: 256px;
              display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            }
            img{
              display: block
            }
            p{
              font-size: 24px;
              letter-spacing: 0px;
              color: #000000;
              padding: 30px 0 50px ;
              font-weight: 600;
            }
          }
        }
      }
    }
    
  }
//公用
  .yuan{
    width: 14px;
    height: 14px;
    background-color: #b2261e;
    border-radius: 50%;
    position: absolute;
  }
  .strang{
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 0px;
    color: #000000;
  }
  .spanallall{
    font-size: 20px;
    letter-spacing: 0px;
    color: #666666;
  }
  .spantineall{
    font-size: 20px;
    width: 56px;
    display: inline-block;
    padding: 0 20px 0 20px;
    letter-spacing: 0px;
    color: #000000;
  }
  .spanbuttonleft{
      position: absolute;
      right: 42px;
      top: -22px;
      display: block;
      width: 121px;
      height: 61px;
      background-color: #e6e6e6;
      opacity: 0.75;
      
      font-size: 34px;
      text-align: center;
      line-height: 61px;
      letter-spacing: 0px;
      color: #b2261e;
  }
  .businessp1{
      
      font-size: 32px;
      // line-height: 53px;
      letter-spacing: 5px;
      color: #333333;
      padding: 110px 0 24px 0;
      font-weight: 600;
  }
  .businessp2{
      
      font-size: 16px;
      letter-spacing: 4px;
      color: #666666;
      padding-bottom:80px; 
  }
 
</style>
